module.exports = __webpack_public_path__ + "img/图像23.e3708db8.png";